const locale = {
    placeholder: 'Seleccionar hora',
};
export default locale;
